import {isAuthPage} from './authPages'

// When support sets a temporary password, Rails stamps the user's
// password_change_required_at. Until the user chooses their own password, every
// page sends them to this one.
export const CHOOSE_PASSWORD_PATH = '/choose-new-password'

function withoutQuery (path) {
  return path.split(/[?#]/)[0].replace(/(.)\/$/, '$1')
}

// Staff viewing an account by impersonation must never be trapped by its flag:
// the change would set the password of the staff member's own login.
export function mustChooseNewPassword ({user, isImpersonating}) {
  return !isImpersonating && Boolean(user && user.password_change_required_at)
}

// Where to send the user after they choose a password: the page they were
// headed to, if it's one that makes sense to return to.
export function afterPasswordChosenPath (redirect) {
  if (typeof redirect !== 'string' || !redirect.startsWith('/') || redirect.startsWith('//')) return '/'
  if (isAuthPage(redirect) || withoutQuery(redirect) === CHOOSE_PASSWORD_PATH) return '/'
  return redirect
}

// The router guard's answer for a navigation to `to` ({path, fullPath, query}):
// a location to redirect to, or null to let it through.
export function choosePasswordRedirect (to, session) {
  const onChoosePage = withoutQuery(to.path) === CHOOSE_PASSWORD_PATH
  if (!mustChooseNewPassword(session)) {
    // Nothing to choose (done already, signed out, or impersonating): move on.
    return onChoosePage ? afterPasswordChosenPath(to.query && to.query.redirect) : null
  }
  // Signed-out pages stay reachable, so signing out from the choose screen works.
  if (onChoosePage || isAuthPage(to.path)) return null
  const location = {path: CHOOSE_PASSWORD_PATH}
  if (to.fullPath && to.fullPath !== '/') location.query = {redirect: to.fullPath}
  return location
}

// The signed-in user and whether staff are viewing it by impersonation, from the
// store's state. On a reload the user comes from localStorage before the auth listener
// restores the impersonation state, so the stored flag counts too; `storage` may throw
// (a private window), which counts as not stored.
export function passwordSession (state, storage) {
  let stored = false
  try {
    stored = storage.getItem('isImpersonating') === 'true'
  } catch (e) {}
  return {
    user: state.user,
    isImpersonating: Boolean(state.isImpersonating || state.impersonatedUid || stored)
  }
}
